export default __webpack_public_path__ + "static/media/logoFiambre-Inicio.9eea0aa1.png";